var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenRectangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 278,
    viewBox: "0 0 261 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.466 277.333C176.675 268.679 89.4092 262.498 1.01971 259.126V34.9177C89.4092 28.6241 176.675 17.3856 260.466 1.42688V277.333Z",
    fill: "#33D076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259.955 1.98865V276.658C176.47 268.005 89.6137 261.936 1.53075 258.452V35.3671C89.5115 29.0735 176.47 17.835 259.955 1.98865ZM260.977 0.640015C177.799 16.4863 90.6355 27.8373 0.508911 34.2432V259.463C90.6355 262.947 177.799 269.129 260.977 277.782V0.640015Z",
    fill: "#33D076"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRectangle);
export default __webpack_public_path__ + "static/media/GreenRectangle.6bd9ce3e927be84a7fd251bfd34b46f6.svg";
export { ForwardRef as ReactComponent };